import {
  Ref,
  RefObject,
  useCallback,
  useEffect,
  useImperativeHandle,
  useState,
} from 'react';
import { TablePanelDropdownRef } from 'components/TablePanelDropdown/TablePanelDropdown.component';
import { FocusFieldRef, OpenFieldPanelRef } from 'models/FieldFocusableModal';

const useOpenFieldPanel = (
  ref: Ref<OpenFieldPanelRef>,
  panel: TablePanelDropdownRef,
  focusableRef: RefObject<FocusFieldRef>,
) => {
  const [pendingFieldKey, setPendingFieldKey] = useState<string>();

  const openField = useCallback(
    (fieldKey: string) => {
      panel?.open();
      setPendingFieldKey(fieldKey);
    },
    [panel],
  );

  useEffect(() => {
    if (!pendingFieldKey || !panel?.isOpen) return;

    focusableRef.current?.focusField(pendingFieldKey);
    setPendingFieldKey(undefined);
  }, [pendingFieldKey, panel, focusableRef]);

  useImperativeHandle(
    ref,
    () => ({
      ...(panel || ({} as TablePanelDropdownRef)),
      openField,
    }),
    [panel, openField],
  );
};

export default useOpenFieldPanel;
